import { render, staticRenderFns } from "./ArrowToRight.vue?vue&type=template&id=23cd5f66"
import script from "./ArrowToRight.vue?vue&type=script&lang=js"
export * from "./ArrowToRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports